'use client';

import { useLocale } from '@instamenu/context-i18n';
import { Button, Text, Container } from '@instamenu/ui-system-next';
import { useUserContext } from '@instamenu/context-user';
import { displayName } from './display-name';
import { usePathname, useRouter } from 'next/navigation';
import { useStripeContext } from './context';
import Link from 'next/link';
import { HTMLAttributes } from 'react';

export default function StripeRequirementsBanner(props: HTMLAttributes<HTMLDivElement>) {
  const { style, className, ...rest } = props;
  const { i18n } = useLocale();
  const router = useRouter();
  const { dueAccounts, showRequirementsBanner } = useStripeContext();
  const { restaurants } = useUserContext();
  const pathname = usePathname();

  if (!showRequirementsBanner) return null;

  if (pathname.includes('settings/compliance')) return null;
  if (dueAccounts.length > 2)
    return (
      <Link
        href="/settings/compliance"
        style={{ textDecoration: 'none', color: 'inherit', marginBottom: 10, ...style }}
        className={className}
      >
        <div style={{ backgroundColor: '#FFAEAE', padding: '10px 0' }}>
          <Container>
            {i18n.t('settings.stripe.requirementsDue', {
              displayName: dueAccounts.length + ' ' + i18n.t('settings.stripe.locations'),
            })}
            {' →'}
          </Container>
        </div>
      </Link>
    );
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, ...style }} {...rest}>
      {dueAccounts.map((account) => (
        <div
          key={account.id}
          style={{ backgroundColor: '#FFAEAE', padding: '10px 0', marginBottom: 10 }}
        >
          <Container
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 32,
            }}
          >
            <Text>
              {i18n.t('settings.stripe.requirementsDue', {
                displayName: displayName(
                  account,
                  restaurants,
                  i18n.t('settings.stripe.defaultDisplayName'),
                ),
              })}
            </Text>
            <Button
              onClick={() => {
                router.push(`/settings/compliance/${account.id}`);
              }}
            >
              {i18n.t('generics.go')}
            </Button>
          </Container>
        </div>
      ))}
    </div>
  );
}
